import { useCallback, useMemo, useState } from 'react';

import { isDefined } from '@acheloisbiosoftware/absui.utils';
import useSpaceInitialPermissionRelationships from 'hooks/useSpaceInitialPermissionRelationships';

const DEFAULT_INIT_STATE = {
  title: '',
  related_sop: null,
  is_template: false,
  permission_relationships: [],
};

export const validateExperimentFormData = (formData) => {
  const { title, related_sop } = formData;
  return Boolean(title) && isDefined(related_sop);
};

const useNewExperimentFormData = (initState) => {
  const initPermissionRelationships = useSpaceInitialPermissionRelationships();
  const initFormData = useMemo(() => ({
    ...DEFAULT_INIT_STATE,
    permission_relationships: initPermissionRelationships,
    ...initState,
  }), [initState, initPermissionRelationships]);

  const [formData, setFormData] = useState(initFormData);
  const valid = validateExperimentFormData(formData);

  const resetFormData = useCallback(() => setFormData(initFormData), [initFormData]);

  const updateFormData = useCallback((key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: typeof(value) === 'function' ? value(prev[key]) : value,
    }));
  }, []);

  return useMemo(() => ({
    formData,
    valid,
    resetFormData,
    updateFormData,
  }), [formData, valid, resetFormData, updateFormData]);
};

export default useNewExperimentFormData;
